export default "__VITE_ASSET__xlHG6S3h__"